import type { LDFlags } from '../../services/types';

import type { LiveBannerData } from './types';

export const LD_LIVE_BANNERS_FLAG_KEY = 'live-banners' satisfies LDFlags;

function isLiveBannerInfrastructureVariation(value: unknown): boolean {
  return (
    typeof value === 'object' && value !== null && Object.prototype.hasOwnProperty.call(value, '_liveBannerVariant')
  );
}

export function liveBannerLdValueToStoreData(raw: unknown): LiveBannerData | null {
  if (raw == null) {
    return null;
  }
  if (typeof raw !== 'object' || isLiveBannerInfrastructureVariation(raw)) {
    return null;
  }
  const o = raw as LiveBannerData;
  return {
    bannerKey: o.bannerKey,
    bannerMessage: o.bannerMessage,
    showLogo: o.showLogo,
    showCloseButton: o.showCloseButton,
    appearanceLimit: o.appearanceLimit,
    activatedAt: new Date(o.activatedAt),
    expiresAt: o.expiresAt ? new Date(o.expiresAt) : null,
  };
}
